import { signalStore } from '@ngrx/signals';
import { FCMActions } from './fcm.action';
import { withActions, withSelectors } from '../../lib/domains/store/ngxs-ngrx.mapper';
import { FCMState } from './fcm.state';

// export type FCMStoreModel = FCMData & { ref: FCMRef };

export const FCMStore = signalStore(
  // Selectors
  { protectedState: false, providedIn: 'root' },
  // withSelectors({
  //   fcms: FCMState.fcms,
  //   fcmState: FCMState.fcmState,
  // }),
  // Actions
  withActions({
    initFCMs: FCMActions.InitFCMs,
    getAllFCMs: FCMActions.GetAllFCM,
    updateFCM: FCMActions.UpdateFCM,
  }),
  withSelectors({
    fcms: FCMState.fcms,
  }),
);
